export var ONLINE_STORES_SPECS;
(function (ONLINE_STORES_SPECS) {
    ONLINE_STORES_SPECS["AddTrackDataOnAddProducts"] = "specs.stores.AddTrackDataOnAddProducts";
})(ONLINE_STORES_SPECS || (ONLINE_STORES_SPECS = {}));
//# sourceMappingURL=constants.js.map